// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"143":"db70ee13","374":"917bcf86"}[chunkId] + ".chunk.css";
};